import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const BureauAddressApi = createAsyncThunk(
  'BureauAddressApi',
  async (bureauAddressPayload, { dispatch }) => {
    dispatch({ type: 'BureauAddressApi/pending', payload: {} });

    const { customerId, Authorization, customerRefNum } = bureauAddressPayload;
    debug('LOOK', `bureauAddressPayload:`, bureauAddressPayload);
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerJourney/bureauaddresses',
      payload: {
        customerRefNum,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response bureauAddressesRes: `, res);
        const bureauAddressesRes = res;
        dispatch({
          type: 'BureauAddressApi/fulfilled',
          payload: bureauAddressesRes,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'BureauAddressApi/rejected', payload: err });
      },
    });
  }
);

export const BureauAddressApi_extrareducer = {
  [BureauAddressApi.pending]: (state, action) => {
    state.bureauAddressApiState.isLoading = true;
  },
  [BureauAddressApi.fulfilled]: (state, action) => {
    state.bureauAddressApiState.isLoading = false;
    state.bureauAddressApiState.isSuccess = true;
    state.bureauAddressApiState.isError = false;
    state.bureauAddressApiState.response = action.payload;
  },
  [BureauAddressApi.rejected]: (state, action) => {
    state.bureauAddressApiState.isLoading = false;
    state.bureauAddressApiState.isSuccess = false;
    state.bureauAddressApiState.isError = true;
    state.bureauAddressApiState.response = action.payload;
  },
};
